import {
    ShoppingCart,
    Zap,
} from "lucide-react";
import "./MobileProductStickyActions.css";

type MobileProductStickyActionsProps = {
    onAddToCart: () => void;
    onBuyNow: () => void;
};

const MobileProductStickyActions = ({
    onAddToCart,
    onBuyNow,
}: MobileProductStickyActionsProps) => {
    return (
        <div className="mobile-product-sticky-actions">
            <div className="mobile-product-sticky-surface">
                <button
                    type="button"
                    className="mobile-product-sticky-button add"
                    onClick={onAddToCart}
                >
                    <span className="mobile-product-sticky-icon">
                        <ShoppingCart size={19} strokeWidth={2.15} />
                    </span>

                    <strong>Add to Cart</strong>
                </button>

                <button
                    type="button"
                    className="mobile-product-sticky-button buy"
                    onClick={onBuyNow}
                >
                    <span className="mobile-product-sticky-icon">
                        <Zap size={19} strokeWidth={2.2} />
                    </span>

                    <strong>Buy Now</strong>
                </button>
            </div>
        </div>
    );
};

export default MobileProductStickyActions;
